import { render, staticRenderFns } from "./PageReadingView.vue?vue&type=template&id=1134cf3c&scoped=true"
import script from "./PageReadingView.vue?vue&type=script&lang=js"
export * from "./PageReadingView.vue?vue&type=script&lang=js"
import style0 from "./PageReadingView.vue?vue&type=style&index=0&id=1134cf3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1134cf3c",
  null
  
)

export default component.exports